import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    headerSkin: '',
    headerSkinDefault: 'bg-gray',
  }),
  getters: {
    headerClass: (s) => s.headerSkin || s.headerSkinDefault,
  },
  actions: {
    setHeaderSkin(val) {
      this.headerSkin = val || '';
    },
    resetHeaderSkin() {
      this.headerSkin = '';
    },
    applyHeaderFromBlocks(blocks) {
      const first = Array.isArray(blocks) ? blocks[0] : null;
      const color = first?.data?.background_color;
      this.setHeaderSkin(mapHeaderClass(color));
    },
  },
});

export function mapHeaderClass(color) {
  if (!color) return '';
  return `bg-${color}`;
}
